import React, { Children } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ContentSection } from './components/ContentSection';
import { EventSection } from './components/EventSection';
import { FlyerSection } from './components/FlyerSection';
import { PartnersSection } from './components/PartnersSection';
import { PartnerForm } from './components/PartnerForm';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-[#1a1a1a] selection:bg-[#4A6FA5] selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />

        <ContentSection id="celebrate" title="Celebrate" text="The Good Father Project recognizes wonderful fathers and father-figures in our communities through essays written by their children. Children submit essays to their schools, which are read and judged by community partners, and winning essays are recognized during a special event." imageSrc="https://cdn.magicpatterns.com/uploads/oGUhJaWrJtCxPVinrhxexe/494644419-9374528632659469-3529350465437840350-n.jpg" imageAlt="Boy reading essays on display" bgColor="bg-gray-50" data-id="element-4" />

        <ContentSection id="honor" title="Honor" text={<>
              We recognize fathers and father-figures within our community,
              together with their children, at special events like the{' '}
              <a href="https://www.downtownharrisonburg.org/best-weekend-ever" target="_blank" rel="noopener noreferrer" className="text-[#4A6FA5] hover:underline font-medium" data-id="element-6">
                Best Weekend Ever in Virginia
              </a>{' '}
              and{' '}
              <a href="https://travishellstrom.com/goodfatherproject" target="_blank" rel="noopener noreferrer" className="text-[#4A6FA5] hover:underline font-medium" data-id="element-7">
                International Children's Day in Mongolia
              </a>
              .
            </>} imageSrc="https://cdn.magicpatterns.com/uploads/3eByi8hQ3ii73YGaPnYjuR/494055202-9374529915992674-2541877543127810459-n_orig.jpg" imageAlt="Father receiving award with daughter" reversed={true} data-id="element-5" />

        <ContentSection id="support" title="Support" text="Fathers and father-figures are encouraged to support one another, start clubs and join initiatives that elevate their communities and help build healthy families. Our current partners include the Harrisonburg Rockingham Fatherhood Initiative in Virginia and the Peace Corps in Mongolia." imageSrc="https://cdn.magicpatterns.com/uploads/q3EERCP2kB5VpFhnu8vzZF/BWE_FULLSET250-118.jpg.webp" imageAlt="Father carrying child on shoulders at community event" bgColor="bg-gray-50" data-id="element-8" />

        <EventSection data-id="element-9" />

        <FlyerSection data-id="element-10" />

        <PartnersSection data-id="element-11" />

        <PartnerForm data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}